import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material ui
import { makeStyles } from "@mui/styles";
import {
  DataGrid,
  GridRow,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { Button, IconButton } from "@mui/material";
// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import PersonIcon from "@mui/icons-material/Person";
import Groups2Icon from "@mui/icons-material/Groups2";
import ArchiveIcon from "@mui/icons-material/Archive";
import ViewCozyIcon from "@mui/icons-material/ViewCozy";
import { Box, Grid, Typography } from "@mui/material";

import { MuiAutocomplete, MuiTooltip } from "../../components";
import { isCheckingAssessmentType } from "./IsCheckingAssessmentType";
import {
  getAccount,
  getAccountById,
} from "../../features/customer/accountSlice";
import { getCustomer } from "../../features/customer/customerSlice";
import { checkObjectLength } from "../common/checkObjectLength/checkObjectLength";
import {
  selectedAccount,
  selectedCustomer,
} from "../../features/customer/accountSlice";
import { CustomerFilterPanel } from "./CustomGridFiter";


// ---------------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  dataGridStyle: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  dataGridStyleNoBackground: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.white.main, // white background
    },
  },
  dataGridRoot: {
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#ECEAEA",
      color: "#2C2A2A",
      fontSize: "0.875rem",
      fontWeight: 500,
    },
  },
}));

// ----------------------------------------------------------------------------------

const CustomRow = (props) => {
  const classes = useStyles();
  const { className, index, ...other } = props;

  return <GridRow index={index} className={classes.dataGridStyle} {...other} />;
};

//   ------------------------------------------------------------------------------------

const GridToolbarAddButton = (props) => {
  return (
    <Button
      variant="text"
      startIcon={<AddCircleIcon />}
      onClick={() => props.handleClick()}
    >
      New
    </Button>
  );
};

// changed the name of the variable
const CustomerDropdown = ({ onChangeCustomerHandle, customerName }) => {
  const dispatch = useDispatch();
  const { customersData } = useSelector((state) => ({ ...state.customer }));
  const { selectedCustomerDataList } = useSelector((state) => ({
    ...state.account,
  }));

  console.log(selectedCustomerDataList);

  return (
    <>
      <MuiAutocomplete
        name="customerName"
        options={customersData}
        value={selectedCustomerDataList}
        setValue={(name, newValue) => {
          onChangeCustomerHandle(newValue);
          dispatch(selectedCustomer(newValue));
          dispatch(selectedAccount(null));
          // dispatch(getAccountById({ assessmentCustomerId: newValue?.id }))

          // .then((res) => {
          //   if (res?.payload?.data?.error) {
          //     setTimeout(() => {
          //       dispatch(taskTypeResetErrMessage());
          //     }, 2000);
          //   }
          // });

          // dispatch(phaseSelect(newValue));
        }}
        optionValue="customerName"
        label="Customers"
        required={false}
        sx={{
          width: "14rem",
          // display: "inline-flex",
          margin: "0.2rem",
          // whiteSpace: "pre-wrap"

          // marginTop: "1rem",
        }}
        size="small"
      />
    </>
  );
};
// changed the name of the variable
const AccountDropdown = ({ onChangeAccountHandle, account, customerName }) => {
  const dispatch = useDispatch();
  const {
    accountData,
    accountIdData,
    selectedAccountDataList,
    selectedCustomerDataList,
  } = useSelector((state) => ({ ...state?.account }));

  return (
    <>
      <MuiAutocomplete
        // disabled={customerName?.id ? false : true}
        name="account"
        options={selectedCustomerDataList?.id ? accountIdData : []}
        value={selectedAccountDataList}
        setValue={(name, newValue) => {
          onChangeAccountHandle(newValue);
          dispatch(selectedAccount(newValue));

          // .then((res) => {
          //   if (res?.payload?.data?.error) {
          //     setTimeout(() => {
          //       dispatch(taskTypeResetErrMessage());
          //     }, 2000);
          //   }
          // });

          //     dispatch(phaseSelect(newValue));
        }}
        optionValue="accountName"
        label="Accounts"
        required={false}
        sx={{
          width: "14rem",
          // display: "inline-flex",

          margin: "0.2rem",
          // whiteSpace: "pre-wrap"
          // marginTop: "1rem",
        }}
        size="small"
      />
    </>
  );
};

const GridToolbarAssessmentType = ({
  onChangeAccountHandle,
  account,
  customerName,
}) => {
  const { accountData, accountIdData } = useSelector((state) => ({
    ...state?.account,
  }));

  return (
    <>
      <MuiAutocomplete
        // disabled={customerName?.id ? false : true}
        name="account"
        options={[]}
        value={account}
        setValue={(name, newValue) => {
          onChangeAccountHandle(newValue);
          // .then((res) => {
          //   if (res?.payload?.data?.error) {
          //     setTimeout(() => {
          //       dispatch(taskTypeResetErrMessage());
          //     }, 2000);
          //   }
          // });

          //     dispatch(phaseSelect(newValue));
        }}
        optionValue="accountName"
        label="Assessment Type"
        required={false}
        sx={{
          width: "14rem",
          // display: "inline-flex",

          margin: "0.2rem",
          // whiteSpace: "pre-wrap"
          // marginTop: "1rem",
        }}
        size="small"
      />
    </>
  );
};

// ------------------------------------------------------------------------------------------

const GridToolbarEditButton = (props) => {
  return (
    <Button
      variant="text"
      startIcon={<EditIcon />}
      onClick={() => props.handleClick()}
    >
      Edit
    </Button>
  );
};
const GridToolbarEditOriginalButton = (props) => {
  return (
    <Button
      sx={{ whiteSpace: "pre-wrap" }}
      variant="contained"
      size="small"
      onClick={() => props.handleClick()}
    >
      Change Status
    </Button>
  );
};

// ---------------------------------------------------------------------------------------------

const GridToolbarDeleteButton = (props) => {
  return (
    <Button
      variant="text"
      startIcon={<DeleteIcon />}
      onClick={() => props.handleClick()}
    >
      Delete
    </Button>
  );
};

const GridToolbarViewButton = (props) => {
  return (
    <Button
      variant="text"
      startIcon={<VisibilityIcon />}
      onClick={() => props.handleClick()}
    >
      View
    </Button>
  );
};

// ----------------------------------------------------------------------------------------------

export default function MuiDataGrid(props) {
  const [selectedRow, setSelectedRow] = useState([]);
  const [custName, setCustName] = useState("");
  const [accountName, setAccountName] = useState("");
  // redux value for checking the selected account if the account is selected
  const { accountIdData, selectedAccountDataList, selectedCustomerDataList } =
    useSelector((state) => ({ ...state?.account }));



  const dispatch = useDispatch();
  const location = useLocation();
  const columns = Array.isArray(
    props.data?.columns,
  )
    ? props.data.columns
    : [];

  const onChangeCustomerHandle = (value) => {
    setCustName(value);
    if (props.getCustomerSelectedValue) {
      props?.getCustomerSelectedValue(value);
    }
  };
  const onChangeAccountHandle = (value) => {
    setAccountName(value);

    if (props.getAccountSelectedValue) {
      props?.getAccountSelectedValue(value);
    }
  };

  // useEffect(() => {
  //   if(props?.selectedCustValue){
  //     console.log("comming inside one")
  //     setCustName(props?.selectedCustValue);
  //     dispatch(selectedCustomer(props?.selectedCustValue))
  //   }
  //   if(props?.selectedAccountValue){
  //       console.log("comming inside two")
  //    setAccountName(props?.selectedAccountValue);
  //     dispatch(selectedAccount(props?.selectedAccountValue))
  //   }

  //  }, [props?.selectedCustValue, props?.selectedAccountValue])

  console.log(custName);

  // when the component mounts check if there is any data present in the location if it is present then set the data
  // useEffect(() => {
  //   if (location?.state?.selectedCustValue) {
  //     setCustName(location.state.selectedCustValue);

  //     if (props?.getCustomerSelectedValue) {
  //       props?.getCustomerSelectedValue(location.state.selectedCustValue);
  //     }
  //   }
  // }, []);

  const selectedAccountFromLocation = location?.state?.selectedAccountValue;

  // when the component mounts check if there is any data in the selected account if it present then filter that data with
  // the array of data and set those values
  useEffect(() => {
    if (selectedAccountFromLocation?.id && accountIdData?.length > 0) {
      const matchedAccount = accountIdData.find(
        (acc) => acc.id === selectedAccountFromLocation.id,
      );

      if (matchedAccount) {
        setAccountName(matchedAccount);
        props?.getAccountSelectedValue?.(matchedAccount);
      }
    }
  }, [accountIdData]);

  useEffect(() => {
    if (selectedCustomerDataList?.id) {
      dispatch(
        getAccountById({ assessmentCustomerId: selectedCustomerDataList?.id }),
      );
    }
    if (
      props?.getCallBackCustomer &&
      selectedCustomerDataList?.id &&
      !selectedAccountDataList?.id
    ) {
      dispatch(props?.getCallBackCustomer(selectedCustomerDataList?.id));
    }

    if (!selectedCustomerDataList?.id && props?.getCallBackOne) {
      dispatch(props?.getCallBackOne());
    }
    if (!selectedCustomerDataList?.id && props?.getCallBackargs) {
      props?.getCallBackargs();
    }
    // setAccountName("")
    if (props?.getCustomerSelectedValue) {
      props?.getCustomerSelectedValue(selectedCustomerDataList);
    }
    if (props.getAccountSelectedValue) {
      props?.getAccountSelectedValue("");
    }
  }, [selectedCustomerDataList]);

  useEffect(() => {
    console.log(selectedCustomerDataList);
    if (props?.getCallBackThree && selectedAccountDataList?.id) {
      props?.getCallBackThree(selectedAccountDataList?.id);
    }

    if (props?.getCallBackTwo && selectedAccountDataList?.id) {
      dispatch(props?.getCallBackTwo(selectedAccountDataList?.id));
    }
    if (props?.getAccountSelectedValue) {
      props?.getAccountSelectedValue(selectedAccountDataList);
    }

    console.log(
      selectedCustomerDataList?.id &&
        !selectedAccountDataList?.id &&
        // given this condition because faced page crash telling props.getCallBackCustomer is not a function for that gave
        // this condition
        typeof props?.getCallBackCustomer === "function",
    );
    if (
      selectedCustomerDataList?.id &&
      !selectedAccountDataList?.id &&
      // given this condition because faced page crash telling props.getCallBackCustomer is not a function for that gave
      // this condition
      typeof props?.getCallBackCustomer === "function"
    ) {
      console.log("account-not-selection-comming");
      dispatch(props?.getCallBackCustomer(selectedCustomerDataList?.id));
    }
  }, [selectedAccountDataList]);

  // useEffect(() => {

  //   if (props?.getCallBackTwo) {
  //     dispatch(props?.getCallBackTwo(accountName?.id ? accountName?.id : null))
  //   }

  // }, [accountName])

  // this use effect is used when the user changes the assessment type that time we need to reset the selected customer and
  // account this condition need to check
  // useEffect (() => {
  //   setCustName("");
  //   setAccountName("");
  // },[props?.assessmentType])

  const classes = useStyles();

  const CustomToolbar = ({ props, selectedRow }) => {
    const touchTargetSx = {
      minWidth: "44px",
      minHeight: "44px",
      width: "44px",
      height: "44px",
      padding: "8px",
    };

    return (
      <GridToolbarContainer>
        {/* for the responsivess issue updated the flexWrap CSS */}
        <Grid
          container
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "row",
              flexGrow: 1,
              flexShrink: 1,
              flexWrap: "wrap",
            }}
          >
            {props.setShowAdd && (
              <GridToolbarAddButton handleClick={props.setShowAdd} />
            )}
            {props.toolbarColumn && <GridToolbarColumnsButton />}
            {props.toolbarColumn && <GridToolbarColumnsButton />}
            {props.toolbarFilter && <GridToolbarFilterButton />}
            {props.toolbarDensity && <GridToolbarDensitySelector />}
            {props.toolbarExport && <GridToolbarExport />}
            {props?.isViewArchived && (
              <MuiTooltip
                title={
                  !props?.viewArchived ? "View Archived Records" : "View All"
                }
                placement="bottom"
              >
                {!props?.viewArchived ? (
                  <IconButton
                    onClick={props?.handleArchiveClick}
                    color="primary"
                    aria-label="View Archived Records"
                    component="span"
                  >
                    <ArchiveIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={props?.handleArchiveClick}
                    color="primary"
                    aria-label="View Un-Archived Records"
                    component="span"
                  >
                    <ViewCozyIcon />
                  </IconButton>
                )}
              </MuiTooltip>
            )}

            {selectedRow.length === 1 && props.setShowView && (
              <GridToolbarViewButton handleClick={props.handleView} />
            )}
            {selectedRow.length === 1 && props?.setShowEdit && (
              <GridToolbarEditButton handleClick={props.setShowEdit} />
            )}
            {selectedRow.length === 1 && props.setShowDelete && (
              <GridToolbarDeleteButton handleClick={props.setShowDelete} />
            )}
            {selectedRow.length === 1 && props?.setShowEditButton && (
              <GridToolbarEditOriginalButton
                handleClick={props.handleUpdateClickOpen}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            style={{ flexGrow: 1, flexShrink: 1 }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              {props?.isCustomer && (
                <CustomerDropdown
                  customerName={custName}
                  onChangeCustomerHandle={(data) =>
                    onChangeCustomerHandle(data)
                  }
                />
              )}
              {props?.isAccount && (
                <AccountDropdown
                  customerName={custName}
                  account={accountName}
                  onChangeAccountHandle={(data) => onChangeAccountHandle(data)}
                />
              )}
              {props?.isAssessmentType && (
                <GridToolbarAssessmentType
                  customerName={custName}
                  account={accountName}
                  onChangeAccountHandle={(data) => onChangeAccountHandle(data)}
                />
              )}

              {props?.isPreview && (
                <Typography sx={{ alignSelf: "center", marginRight: "2rem" }}>
                  Total Questions:{props?.data?.rows?.length}
                </Typography>
              )}

              {props?.isPreview && (
                <MuiTooltip title="Preview" placement="bottom">
                  <IconButton
                    sx={touchTargetSx}
                    color="primary"
                    component={Link}
                    to="/preview-questions"
                    aria-label="Preview"
                    state={{
                      fromOne: "Self",
                      from: props?.template?.id,
                      company:
                        props?.template?.assessmentCustomerAccount
                          ?.assessmentCustomer?.customerName,
                      permissions: props?.permissions,
                      templateSelectedData: props?.template,
                      assessmentType: location?.state?.assessmentType,
                      selectedCustValue: location?.state?.selectedCustValue,
                      selectedAccountValue:
                        location?.state?.selectedAccountValue,
                    }}
                  >
                    <PreviewIcon sx={{ fontSize: "2rem" }} />
                  </IconButton>
                </MuiTooltip>
              )}

              {props?.isPreview && (
                <MuiTooltip title="Client Preview" placement="bottom">
                  <IconButton
                    sx={touchTargetSx}
                    color="primary"
                    component={Link}
                    to="/survey_start"
                    aria-label="Client Preview"
                    state={{
                      fromOne: "Self",
                      from: props?.template?.id,
                      account:
                          props?.template?.assessmentCustomerAccount?.accountName,
                      company:
                        props?.template?.assessmentCustomerAccount?.assessmentCustomer?.customerName,
                      isAccountDisplayRequired:
                        props?.template?.assessmentCustomerAccount
                          ?.assessmentCustomer?.isAccountDisplayRequired,
                      permissions: props?.permissions,
                      templateSelectedData: props?.template,
                      assessmentType: location?.state?.assessmentType,
                      selectedCustValue: location?.state?.selectedCustValue,
                      selectedAccountValue:
                        location?.state?.selectedAccountValue,
                    }}
                  >
                    <PersonIcon sx={{ fontSize: "2rem" }} />
                  </IconButton>
                </MuiTooltip>
              )}

              {props?.isPreview &&
                isCheckingAssessmentType(
                  props?.template?.assessmentType?.code,
                ) && (
                  <MuiTooltip title="Assessor Preview" placement="bottom">
                    <IconButton
                      sx={touchTargetSx}
                      color="primary"
                      component={Link}
                      to="/survey_start"
                      aria-label="Assessor Preview"
                      state={{
                        fromOne: "stakeholder",
                        from: props?.template?.id,
                        account:
                          props?.template?.assessmentCustomerAccount
                            ?.accountName,
                        company:
                          props?.template?.assessmentCustomerAccount
                            ?.assessmentCustomer?.customerName,
                        isAccountDisplayRequired:
                          props?.template?.assessmentCustomerAccount
                            ?.assessmentCustomer?.isAccountDisplayRequired,
                        permissions: props?.permissions,
                        templateSelectedData: props?.template,
                        assessmentType: location?.state?.assessmentType,
                        selectedCustValue: location?.state?.selectedCustValue,
                        selectedAccountValue:
                          location?.state?.selectedAccountValue,
                      }}
                    >
                      <Groups2Icon sx={{ fontSize: "2rem" }} />
                    </IconButton>
                  </MuiTooltip>
                )}
            </Box>
          </Grid>
        </Grid>
      </GridToolbarContainer>
    );
  };

  return (
    <div
      style={{
        height: props.height ? props.height : 500,
        width: "100%",
        // "&.superAppTheme": {
        //   "&:nth-of-type(odd)": {
        //     bgcolor: (theme) => theme.palette.primary.light,

        //   },
        // },
      }}
    >
      <DataGrid
        autoHeight={props?.autoLength ? true : false}
        className={classes.filter_grid}
        rows={Array.isArray(props.data?.rows) ? props.data.rows : []}
        columns={Array.isArray(props.data?.columns) ? props.data.columns : []}
        slots={{
          toolbar: CustomToolbar,
            filterPanel: () => (
            <CustomerFilterPanel
              columns={columns}
            />
          ),
        }}
        showToolbar
        slotProps={{
          toolbar: {
            props,
            selectedRow,
          },
        }}
        getRowClassName={() =>
          props.noBlueBackground
            ? classes.dataGridStyleNoBackground
            : classes.dataGridStyle
        }
        pageSize={100}
        // rowsPerPageOptions={[25]}
        // pagination
        onRowSelectionModelChange={(ids) => {
          const selectedRowData = Array.isArray(props.data?.rows)
            ? props.data.rows.filter(
                (row) => ids.length > 0 && row.id === ids[0],
              )
            : [];

          props.select?.(selectedRowData);
          setSelectedRow(selectedRowData);
        }}
      />
    </div>
  );
}
